import { ls } from 'utils/my-localstorage'
import { shallowEqual } from 'react-redux'
import { setSelectedCompanyId, setCompanyTour } from 'store/me'
import { getPersonCategory } from 'utils/company'
import { PersonCategories, Roles } from 'utils/consts/userRoles'
import { PROHIBITED } from 'utils/consts/companyStatus'
import { useGetCompanyLazyQuery } from 'api/hooks'
import { useAppDispatch, useAppSelector } from 'store/hooks'
import type { RootState } from 'store'
import type { SelectedCompany } from 'store/me'

export const useSelectedCompany = () => {
  return useAppSelector(state => {
    const selectedCompanyId = state?.me?.selectedCompanyId

    if (!selectedCompanyId || selectedCompanyId === '0') return null

    const personCompanies = state?.me?.data?.companies ?? []

    return personCompanies.find(company => {
      return company?.id === selectedCompanyId
    })
  })
}

export function useChangeCompany() {
  const dispatch = useAppDispatch()
  const [getCurrentCompanyTour] = useGetCompanyLazyQuery()
  const getTour = async companyId => {
    try {
      const { data } = await getCurrentCompanyTour({
        variables: { companyId },
      })
      return data?.me?.company?.tour
    } catch {
      return
    }
  }

  return async company => {
    const id = company?.id || '0'
    const companyTour = await getTour(id)
    dispatch(
      // @ts-ignore
      setCompanyTour({ companyId: id, tour: companyTour })
    )
    const category =
      company?.companyCategory?.masterName ?? PersonCategories.PERSON

    const isVerifiedUser = company?.isVerifiedUser ?? false

    ls.setItem('wwl-selected_company_id', id.toString())
    ls.setItem('wwl-person_category', category)
    ls.setItem('wwl-verified_company', isVerifiedUser.toString())

    dispatch(setSelectedCompanyId(id))
  }
}

export const getUserDataForRoutes = (state: RootState) => {
  const selectedCompanyId = state?.me?.selectedCompanyId

  const lsRole = ls.getItem('wwl-role_code')
  const storeRole = state?.me?.data?.role?.code
  const lsPersonCategory = getPersonCategory()

  const lsIsVerified = ls.getItem('wwl-verified_company') === 'true'

  const company = (state?.me?.data?.companies ?? []).find(company => {
    return company?.id === selectedCompanyId
  }) as SelectedCompany

  const storeCompanyCategory = company?.companyCategory?.masterName

  const isProhibited = company?.verificationStatus?.code === PROHIBITED

  return {
    role: storeRole || lsRole || Roles.PERSON,
    category:
      storeCompanyCategory || lsPersonCategory || PersonCategories.PERSON,
    isVerified:
      company?.isVerifiedUser === undefined
        ? lsIsVerified || false
        : company?.isVerifiedUser,
    hasAccessToSellWine: company?.hasAccessToSellWine ?? false,
    hasAccessToRetail: company?.hasAccessToRetail ?? false,
    isProhibited,
  }
}

export const useUserDataForRoutes = () => {
  return useAppSelector(getUserDataForRoutes, shallowEqual)
}
